module.exports = __webpack_public_path__ + "img/FR16648.1237ea98.svg";